import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';

import { SpConnectTaskInterface } from '../interfaces/sp-connect-task.interface';

export class SpConnectTaskDto implements SpConnectTaskInterface {
  @ApiProperty()
  @IsOptional()
  name?: string;

  @ApiProperty()
  @IsOptional()
  taskNum?: string;

  @ApiProperty()
  @IsOptional()
  description?: string;
}
